import React from 'react';
import { CommonDeleteModal } from 'components/common';
import { useDeleteModal } from './useDeleteModal';

interface DeleteModal {
  openModal: boolean;
  dataToDelete: { id: string | undefined };
  onDeleteModalClose: () => void;
}

export const DeleteModal = (props: DeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete } = props;
  const { onRemoveConfirm, contextHolder, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <>
      {contextHolder}
      <CommonDeleteModal
        onCancel={onDeleteModalClose}
        open={openModal}
        isLoading={isLoading}
        onOk={() => onRemoveConfirm(dataToDelete)}
        onClose={onDeleteModalClose}
        title={'Delete Pricelist'}
        message={'Are you sure you want to delete this pricelist?'}
      />
    </>
  );
};
